<template>
  <div id="app">
    <el-container>
      <el-container>
        <el-header height="auto">
          <MyHeader></MyHeader>
        </el-header>
        <el-main>
          <MyMain></MyMain>
        </el-main>
        <el-footer height="140px">
          <MyFooter></MyFooter>
        </el-footer>
      </el-container>
      <!-- <MyHeader></MyHeader>
      <MyMain></MyMain>
      <MyFooter></MyFooter> -->
    </el-container>
  </div>
</template>

<script>
import MyHeader from '@/layout/header.vue'
import MyMain from '@/layout/main.vue'
import MyFooter from '@/layout/footer.vue'
export default {
  name: 'App',
  components: {
    MyHeader, MyMain, MyFooter
  }
}
</script>

<style lang="scss" scoped>
#app {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .el-header {
    padding: 0;
    height: auto;
    min-width: 1300px;
  }

  .el-main {
    padding: 10px 11% 10px;
  }

  .el-footer {
    background-color: #ebebeb;
  }
}
</style>
